<template>
  <v-card>
    <v-toolbar dark dense flat :color="appColor_Medium">
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>  
    <v-card-text class="mt-4 px-4">
      <v-select
        v-model="selectedExportType"
        :items="exportTypes"
        label="Export As..."
        :disabled="isExporting"
        hide-details
    />
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn text @click="$emit('cancel')" :disabled="isExporting">Cancel</v-btn>
      <v-btn
        text
        :color="appColor_ButtonOK"
        :loading="isExporting"
        :disabled="isExporting || selectedExportType.length === 0"
        @click="ok"
        >OK
        <span slot="loader" class="custom-loader">
          <v-icon>cached</v-icon>
        </span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { AppColor } from '@/config.js'

export default {
  name: "AppExport",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Export"
    }//,
    // isExporting: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data: () => ({
    appColor_Medium: AppColor.Medium,
    appColor_ButtonOK: AppColor.ButtonOK,
    isExporting: false,
    selectedExportType: '',
    exportTypes: [{
      value: 'xlsx',
      text: 'Excel'
    },
    {
      value: 'csv',
      text: 'CSV'
    },
    {
      value: 'txt',
      text: 'Text'
    }],   
  }),
  methods: {
    ok () {
      this.isExporting = true
      this.$emit('input', true)
      const exportType = this.selectedExportType
      this.$emit('ok', { exportType })
    }
  },
  watch: {
    value (v) {
      if (v === null) return
      this.isExporting = v
    }
  }
}
</script>
